const Avatar = ({ src, name }) => {
	return (
		<div className="relative w-12 h-12">
			{src ? (
				<img src={src} alt={`${name}' avatar`} />
			) : (
				<AvatarFallBack name={name} />
			)}
		</div>
	);
};

function getAvatarFallback(fullName) {
	if (!fullName || fullName.trim() === "") {
		return "?";
	}

	const parts = fullName.trim().split(/\s+/);

	if (parts.length === 1) {
		return parts[0][0].toUpperCase();
	}

	const firstInitial = parts[0][0].toUpperCase();
	const lastInitial = parts[parts.length - 1][0].toUpperCase();

	return `${firstInitial}${lastInitial}`;
}

function stringToColor(str) {
	let hash = 0;
	const avatarColors = [
		"#F44336", // Red
		"#E91E63", // Pink
		"#9C27B0", // Purple
		"#673AB7", // Deep Purple
		"#3F51B5", // Indigo
		"#2196F3", // Blue
		"#03A9F4", // Light Blue
		"#00BCD4", // Cyan
		"#009688", // Teal
		"#4CAF50", // Green
		"#FF9800", // Orange
		"#795548", // Brown
	];

	for (let i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 12) - hash);
	}

	const index = Math.abs(hash) % avatarColors.length;

	return avatarColors[index];
}

const AvatarFallBack = ({ name }) => {
	const initials = getAvatarFallback(name);
	const color = stringToColor(name);
	return (
		<div
			style={{
				borderColor: color,
				backgroundColor: `${color}0F`,
			}}
			className="w-12 h-12 rounded-full border font-medium text-lg flex items-center justify-center"
		>
			<div style={{ color }}>{initials}</div>
		</div>
	);
};

export default Avatar;
